(function () {
    'use strict';

    async function main() {
        var page = wo$('#landing');
        if (!page.length) return;
        var savedMaxResults = null;
        var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
        var filtersData = WhistleOut.readLookupData(wo$('#search-filters-partial'));

        var landingPageController = {
            init: async function () {
                if (criteria) {
                    savedMaxResults = criteria.maxResults;
                    landingPageController.registerNotifications();
                    landingPageController.loadSearchModal();
                    landingPageController.bindPlanSummary();
                    landingPageController.bindPhoneSummary();
                    landingPageController.bindCriteriaFilters();
                    wo$('#express-search-action').hide();
                    page.find('[data-carousel-phone="' + criteria.lines[0].phone + '"]')
                        .parent()
                        .addClass('selected');
                    landingPageController.bindCarousel();
                    wo$('.responsive').on('init', function () {
                        landingPageController.bindCarousel();
                    });
                }
                await WhistleOut.bindSlick();
                WhistleOut.getAds('MobilePhones');
            },

            bindCarousel: function () {
                page.find('[data-carousel-phone]')
                    .off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        page.find('.slick-slide').removeClass('selected');
                        wo$(this).parent().addClass('selected');
                        var phoneShortUrl = wo$(this).data('carousel-phone');
                        criteria.lines[0].phone = phoneShortUrl;
                        criteria.productLabel = null;
                        WhistleOut.scrollTo('#landing-results');
                        WhistleOut.notifications.fire('FilterChanged', { type: 'PhoneCarousel', criteria: criteria });
                    });
            },

            bindCriteriaFiltersLegacy: function () {
                page.find(
                    '[data-criteria-phone],[data-criteria-supplier],[data-criteria-data],[data-criteria-network],[data-criteria-prepaidexpiry],[data-criteria-maxprepaidexpiry]'
                )
                    .off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        if (wo$(this).data('criteria-phone')) {
                            criteria.lines[0].phone = wo$(this).data('criteria-phone');
                        }
                        if (wo$(this).data('criteria-data')) {
                            criteria.lines[0].data = wo$(this).data('criteria-data');
                        }
                        if (wo$(this).data('criteria-network')) {
                            criteria.network = [wo$(this).data('criteria-network')];
                        }
                        if (wo$(this).data('criteria-prepaidexpiry')) {
                            criteria.prepaidExpiry = wo$(this).data('criteria-prepaidexpiry');
                        }
                        if (wo$(this).data('criteria-maxprepaidexpiry')) {
                            criteria.maximumPrepaidExpiry = wo$(this).data('criteria-maxprepaidexpiry');
                        }
                        if (wo$(this).data('criteria-network')) {
                            criteria.network = [wo$(this).data('criteria-network')];
                        }
                        if (wo$(this).data('criteria-supplier')) {
                            criteria.suppliers = [wo$(this).data('criteria-supplier')];
                        }
                        criteria.productLabel = null;

                        WhistleOut.scrollTo('#landing-results');
                        WhistleOut.notifications.fire('FilterChanged', { type: 'InPlaceCriteria', criteria: criteria });
                    });
            },

            bindCriteriaFilters: function () {
                this.bindCriteriaFiltersLegacy();

                WhistleOut.MobilePhones.bindCriteriaFilters(
                    wo$('body'),
                    function (el, criteria) {
                        WhistleOut.scrollTo('#landing-results');
                        console.log({ criteria });
                        WhistleOut.notifications.fire('FilterChanged', { type: 'InPlaceCriteria', criteria: criteria });
                    },
                    criteria
                );
            },

            registerNotifications: function () {
                WhistleOut.notifications.add(function (notification, data) {
                    if (data && data.criteria && data.type !== 'Page') {
                        data.criteria.page = 1;
                    }

                    if (notification === 'FilterChanged') {
                        wo$('[data-enable-when-ready]').attr('disabled', 'disabled');
                        var isAjax =
                            data.type === 'Sort' ||
                            data.type === 'PhoneCarousel' ||
                            data.type === 'FeaturedResults' ||
                            data.type === 'PlanSummary' ||
                            data.type === 'Supplier' ||
                            data.type === 'InPlaceCriteria' ||
                            data.type === 'PhoneSummary';
                        var reloadFilters =
                            data.type === 'InPlaceCriteria' ||
                            data.type === 'PhoneCarousel' ||
                            data.type === 'PhoneSummary' ||
                            data.type === 'Supplier';
                        landingPageController.updateFilters(data.criteria, !isAjax, reloadFilters);
                    } else if (notification === 'TabChanged') {
                        landingPageController.loadSearchModal();
                    } else if (notification === 'SearchResultsRendered') {
                        landingPageController.loadSearchModal();
                        wo$('#express-search-action').hide();
                        wo$(window).resize();
                    }
                });
            },

            updateFilters: function (criteria, fullReload, reloadFilters) {
                WhistleOut.startProgress('#search-results-partial', 0.1, 50);

                var queryString = '?';
                if (fullReload) {
                    criteria.hideEmptyTabs = false;
                    criteria.showAll = false;
                    criteria.showRowFilters = true;
                    criteria.hideWidenResults = false;
                    criteria.hideShare = false;
                    criteria.hideCoverage = false;
                    criteria.hideCoverageStrip = false;
                    criteria.maxResults = null;
                    criteria.pageSize = null;
                    criteria.productLabel = null;

                    WhistleOut.getCurrentLocation(
                        function (e) {
                            var address = e.label;
                            if (address.length > 1) {
                                criteria.address = address;
                            }
                            queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                            location.href = criteria.searchUrl + queryString;
                        },
                        function () {
                            queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                            location.href = criteria.searchUrl + queryString;
                        }
                    );
                    return;
                } else if (reloadFilters) {
                    queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                    var filtersUrl =
                        (criteria.lines.length > 1
                            ? criteria.multiLineFiltersAjaxUrl
                            : criteria.singleLineFiltersAjaxUrl) + queryString;
                    if (filtersData && filtersData.phoneList && filtersData.phoneList.length > 0) {
                        filtersUrl = WhistleOut.updateQueryStringParameter(
                            filtersUrl + queryString,
                            'phoneList',
                            filtersData.phoneList.join(',')
                        );
                    }
                    wo$.ajax({
                        url: filtersUrl,
                        type: 'GET',
                        success: function (result) {
                            var $filters = wo$('#search-filters-partial');
                            $filters.html(result);
                            wo$(window).resize();
                            WhistleOut.notifications.fire('SearchFiltersRendered');
                        }
                    });
                } else {
                    queryString += WhistleOut.MobilePhones.generateQueryString(criteria);
                }

                var resultsUrl = criteria.lines.length > 1 ? criteria.multiLineAjaxUrl : criteria.singleLineAjaxUrl;
                resultsUrl += queryString;

                wo$.ajax({
                    url: resultsUrl,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#search-results-partial');
                        $results.html(result);
                        WhistleOut.applyPopover($results);
                        WhistleOut.endProgress();
                        WhistleOut.notifications.fire('SearchResultsRendered');
                        wo$(window).resize();
                    },
                    error: function () {
                        WhistleOut.endProgress();
                    }
                });
            },

            loadSearchModal: function () {
                var criteria = WhistleOut.readLookupData(wo$('[data-search-criteria]'));
                var modalUrl =
                    (criteria.lines.length > 1 ? criteria.multiLineModalAjaxUrl : criteria.singleLineModalAjaxUrl) +
                    '?' +
                    WhistleOut.MobilePhones.generateQueryString(criteria);
                if (filtersData && filtersData.phoneList && filtersData.phoneList.length > 0) {
                    modalUrl = WhistleOut.updateQueryStringParameter(
                        modalUrl,
                        'phoneList',
                        filtersData.phoneList.join(',')
                    );
                }
                wo$.ajax({
                    url: modalUrl,
                    type: 'GET',
                    success: function (result) {
                        var $results = wo$('#filters-modal-partial');
                        $results.html(result);
                        WhistleOut.notifications.fire('FiltersModalReady');
                    }
                });
            },

            bindPlanSummary: function () {
                page.find('table[data-plan-summary] tr[data-supplier], table[data-plan-summary] a').click(function () {
                    var supplierShortUrl = wo$(this).data('supplier');
                    criteria.tab = '';
                    if (supplierShortUrl) {
                        if (
                            !criteria.suppliers ||
                            criteria.suppliers.length === 0 ||
                            criteria.suppliers[0] !== supplierShortUrl
                        ) {
                            criteria.suppliers = [supplierShortUrl];
                            criteria.enforcemaximumresultlimits = false;
                            criteria.maxResults = null;
                            WhistleOut.notifications.fire('FilterChanged', { type: 'PlanSummary', criteria: criteria });
                        }
                    } else {
                        if (criteria.suppliers && criteria.suppliers.length > 0) {
                            criteria.suppliers = [];
                            criteria.enforcemaximumresultlimits = true;
                            criteria.maxResults = savedMaxResults;
                            WhistleOut.notifications.fire('FilterChanged', { type: 'PlanSummary', criteria: criteria });
                        }
                    }
                    WhistleOut.scrollTo('#search-results-partial');
                });
            },

            bindPhoneSummary: function () {
                page.find('table[data-phone-summary] tr[data-phone], table[data-phone-summary] a[data-phone]').click(
                    function () {
                        var $this = wo$(this);
                        var phoneShortUrl = $this.data('phone');
                        if (criteria.lines[0].phone !== phoneShortUrl) {
                            page.find('.slick-slide').removeClass('selected');
                            page.find('.slick-slide a[data-carousel-phone = "' + phoneShortUrl + '"]')
                                .parent()
                                .addClass('selected');
                            criteria.lines[0].phone = phoneShortUrl;
                            criteria.enforcemaximumresultlimits = false;
                            criteria.maxResults = null;
                            criteria.productLabel = null;
                            WhistleOut.notifications.fire('FilterChanged', {
                                type: 'PhoneSummary',
                                criteria: criteria
                            });
                        }
                        WhistleOut.scrollTo('#landing-results');
                    }
                );
            }
        };

        await landingPageController.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
